import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/member/login',
    method: 'post',
    data
  })
}

// export function getInfo(data) {
//     return request({
//         url: '/api/member/info',
//         method: 'post',
//         data
//     })
// }
export function getInfo() {
  return request({
    url: '/api/member/info',
    method: 'get'
  })
}

export function userWaybillBalance() {
  return request({
    url: '/api/pay/userWaybillBalance',
    method: 'get'
  })
}

export function logout(token) {
  return request({
    url: '/api/member/logout',
    method: 'get',
    params: { token }
  })
}

export const getPageCode = data => {
  return request({
    url: '/api/home/pagecode',
    method: 'get',
    params: data
  })
}

export const setcode = data => {
  return request({
    url: '/api/home/setcode',
    method: 'post',
    data: data
  })
}

// 获取授权链接
export const getAuthLink = type => {
  return request({
    url: '/api/auth/auth_link',
    method: 'get',
    params: { channel: type }
  })
}
